import wealth from "constants/wealth";
import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from "html-react-parser";
import "../personal.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { LinkButton } from "components/buttons";
import briefcase from "assets/images/briefcase.svg";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";

function SinarBaraqah() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Wealth Management"
          title={`Sinar <span className="jumbotron-subtitle-2">Baraqah<span>`}
          buttonText="Talk to us"
        />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{wealth.sinarBaraqah.about.title}</h2>
            </Col>
            <Col md={8}>{parse(wealth.sinarBaraqah.about.description)}</Col>
          </Row>
          <Row className="my-5 py-5">
            <Col>
              <div className="features-container">
                {wealth.sinarBaraqah.features.description.map(
                  (feature, index) => (
                    <div
                      className="features-card w-100"
                      data-aos="fade-right"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(feature)}
                    </div>
                  )
                )}
              </div>
            </Col>
          </Row>
          <Row className="py-4 rounded-4">
            <Col
              md={6}
              className="d-flex flex-column align-items-center justify-content-center unit-trust-about"
            >
              <div
                className="container mt-5"
                data-aos="fade-down"
                data-aos-delay="100"
              >
                <h4>{parse(wealth.sinarBaraqah.knowledge.title)}</h4>
                <div className="my-4 text-black-50">
                  <div className="mb-3">
                    {parse(wealth.sinarBaraqah.knowledge.subtitle)}
                  </div>
                  {wealth.sinarBaraqah.knowledge.description.map(
                    (description, index) => (
                      <div className="eligibility-list" data-aos="zoom-in-down">
                        <img src={briefcase} width="16" alt="outline_check" />
                        {parse(description)}
                      </div>
                    )
                  )}
                </div>
                <div className="my-4 text-black-50">
                  {parse(wealth.unitTrust.partners.footnotes)}
                </div>
              </div>
            </Col>
            <Col md={6} className="container d-flex justify-content-end">
              <img
                src={wealth.sinarBaraqah.knowledge.image}
                width="100%"
                className="rounded-3"
                alt="unit trust"
                data-aos="fade-right"
              />
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col>
              <h2>{wealth.sinarBaraqah.benefits.title}</h2>
              <div className="text-black-50">
                <ol>
                  {wealth.sinarBaraqah.benefits.description.map(
                    (benefit, index) =>
                      index === 1 ? (
                        <img
                          src={benefit}
                          alt="Conversion of Physical Gold"
                          height="100%"
                        />
                      ) : (
                        <div className="my-3">{parse(benefit)}</div>
                      )
                  )}
                </ol>
                <div className="pt-4">
                  {wealth.sinarBaraqah.benefits.terms.map((terms, index) => (
                    <div className="my-3">{parse(terms)}</div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="my-5">
            <Col>
              <div className="d-flex flex-row flex-wrap gap-3">
                <LinkButton
                  text="Product Disclosure Sheet - Plan 125"
                  onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/Sinar Baraqah PDS (Plan 125).pdf`)}
                />
                <LinkButton
                  text="Product Disclosure Sheet - Plan 175"
                  onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/Sinar Baraqah PDS (Plan 175).pdf`)}
                />
                <LinkButton
                  text="Product Disclosure Sheet - Plan 250"
                  onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/Sinar Baraqah PDS (Plan 250).pdf`)}
                />
                <LinkButton
                  text="Product Disclosure Sheet - Plan 375"
                  onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/Sinar Baraqah PDS (Plan 375).pdf`)}
                />
                <LinkButton
                  text="Product Disclosure Sheet - Plan 500"
                  onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/wealth/Sinar Baraqah PDS (Plan 500).pdf`)}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>Let's connect!</h2>
              <span className="text-black-50">
                Share your information, and we'll get back to you with the
                answers you need.
              </span>
            </Col>
            <Col md={8}>
              <EnquiryForm />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default SinarBaraqah;
